import { Action } from 'redux';
// Import States.
import {
	AppState,
	PolicyState,
	getInitialPolicyState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadPolicyCopyEligiblityStatusAction,
	PolicyAction,
} from '@app/redux/actions';

/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState, action: PolicyAction): AppState => {
	let newState: AppState = { ...state };
	// Initialize the state.
	if (newState.policies[action.policyId] === undefined) {
		newState.policies[action.policyId] = getInitialPolicyState();
	}
	else {
		newState.policies[action.policyId] = { ...newState.policies[action.policyId] }
	}

	return newState;
}


/**
 * Query the state.
 * @param state
 * @param action
 */
let queryPolicyState = (state: AppState, action: PolicyAction): PolicyState => {
	return state.policies[action.policyId];
}


// Load Policy Copy Eligiblity Status Reducer.

let LoadPolicyCopyEligiblityStatusReducer = (state: AppState, action: Action): AppState => {
	let loadPolicyCopyEligiblityStatusAction: LoadPolicyCopyEligiblityStatusAction = action as LoadPolicyCopyEligiblityStatusAction;
	let canPolicyBeCopied: boolean = loadPolicyCopyEligiblityStatusAction.canPolicyBeCopied;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, loadPolicyCopyEligiblityStatusAction);

	// Query the state.
	let policyState: PolicyState = queryPolicyState(newState, loadPolicyCopyEligiblityStatusAction);

	policyState.canPolicyBeCopied = canPolicyBeCopied;

	return newState;
}

// Export initializers.
export {
	initializeState
}

// Export queries.
export {
	queryPolicyState
};

// Export reducers.
export {
	LoadPolicyCopyEligiblityStatusReducer,
};